<template>
<router-view></router-view>
</template>
<script>
import { mapActions } from "vuex"

export default {
    name: 'app',
    methods: {
        ...mapActions('auth', ['current']),
        ...mapActions('catalogue', ['reloadCatalogueItem']),
        ...mapActions('messaging', ['getNavBar']),

        async handleMessageReceived(message) {
            const data = JSON.parse(message)

            if (data.type === "planning") {
                EventBus.$emit('planning-socket', data.payload)
            }
            
            if (data.type === "messaging") {
                EventBus.$emit('messaging-socket', data.payload)
            }

            if (data.type === "interchange") {
                EventBus.$emit('interchange-socket', data.payload)
            }

            if (data.type === "catalogue") {
                const item = data.payload.message
                await this.reloadCatalogueItem(item)
            }

            if (data.type === "permissions") {
                await this.current()
            }
        }
    },
    async mounted() {
        this.$websocket.$on('messageReceived', this.handleMessageReceived)
        this.$websocket.connect(`${window.location.host}/ws/app/`)

    },
    beforeDestroy() {
        this.$websocket.$off('messageReceived', this.handleMessageReceived)
        this.$websocket.disconnect()
    }

}
</script>

<style lang="scss">
    /* Import Font Awesome Icons Set */
    $fa-font-path: './assets/fontawesome/webfonts';
    @import './assets/fontawesome/scss/fontawesome.scss';
    @import './assets/fontawesome/scss/solid.scss';
    @import './assets/fontawesome/scss/regular.scss';
    @import './assets/fontawesome/scss/light.scss';
    @import './assets/fontawesome/scss/sharp-light.scss';
    @import './assets/fontawesome/scss/sharp-regular.scss';
    @import './assets/fontawesome/scss/sharp-solid.scss';

    /* Import Bootstrap Vue Styles */
    @import '~bootstrap-vue/dist/bootstrap-vue.css';

    /* Import Main styles for this application  */
    @import './assets/scss/style';
</style>